<footer class="footer-modern text-light mt-4 position-relative">
  <div class="container py-5">
    <div class="row g-4">
      <div class="col-md-4">
        <div class="footer-title">Contatti</div>
        <ul class="list-unstyled footer-list mb-0">
          <li>Via Tirino 145, Pescara 65125</li>
          <li>
            <a class="footer-link" href="/impresa-pulizie-giulianova-teramo" routerLink="/impresa-pulizie-giulianova-teramo">
              Corso Nazario Sauro 118, Giulianova (TE)
            </a>
          </li>
          <li class="footer-phones">
            <a href="tel:08554360" class="footer-link">
              <strong>Sede di Pescara</strong><br />085 54360
            </a>
            <a href="tel:0859155805" class="footer-link">
              <strong>Sede di Giulianova</strong><br />085 9155805
            </a>
          </li>
          <li>
            <a href="mailto:info@samipulizie.it" class="footer-link"
              >E-mail: info@samipulizie.it</a
            >
          </li>
          <li>
            <a href="mailto:commerciale.te@samipulizie.it" class="footer-link">
              Commerciale Teramo: commerciale.te@samipulizie.it
            </a>
          </li>
        </ul>
      </div>

      <div class="col-md-4 text-md-center">
        <div class="footer-title">Orario Ufficio</div>
        <ul class="list-unstyled footer-list mb-0">
          <li>08:30 - 12:30 / 15:00 - 18:30</li>
        </ul>
      </div>

      <div class="col-md-4 text-md-end">
        <div class="footer-title">Link Utili</div>
        <ul class="list-unstyled footer-list mb-0">
          <li>
            <a class="footer-link" href="/" routerLink="/">Home</a>
          </li>
          <li>
            <a class="footer-link" href="/privacy" routerLink="/privacy">Privacy</a>
          </li>
          <li>
            <a class="footer-link" href="/impresa-pulizie-giulianova-teramo" routerLink="/impresa-pulizie-giulianova-teramo">Sede Giulianova e area Teramo</a>
          </li>
          <!-- Se questa rotta esiste ok. Se NON esiste dimmelo e lo cambiamo -->
          <li>
            <a
              class="footer-link"
              href="/convenzioni-promozioni"
              routerLink="/convenzioni-promozioni"
              >Convenzioni e Promozioni</a
            >
          </li>
        </ul>
      </div>
    </div>

    <hr class="footer-sep my-4" />

    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3"
    >
      <a
        href="https://mvtechcore.it/"
        target="_blank"
        rel="noopener noreferrer"
        class="footer-credit"
      >
        Realizzato da MV TechCore
      </a>

      <div class="d-flex gap-2">
        <a
          href="https://www.facebook.com/sami.impresadipulizie"
          target="_blank"
          rel="noopener noreferrer"
          class="social-btn"
          aria-label="Facebook"
        >
          <i class="fa-brands fa-facebook-f"></i>
        </a>

        <a
          href="https://www.instagram.com/samipulizie/"
          target="_blank"
          rel="noopener noreferrer"
          class="social-btn"
          aria-label="Instagram"
        >
          <i class="fa-brands fa-instagram"></i>
        </a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container text-center py-3">
      <div class="small opacity-75">
        Servizi attivi a Pescara, Montesilvano, Francavilla al Mare, Chieti e zone limitrofe.
        Per Giulianova, Teramo, Roseto, Alba Adriatica, Tortoreto,
        Silvi, Pineto, Martinsicuro e provincia, contatta la sede di Giulianova.
      </div>
      <div class="small mt-2">© 2026 SAMI Pulizie - Tutti i diritti riservati</div>
    </div>
  </div>
</footer>
